<template>
  <v-g-editor id='vg-editor' class="work-flow-graph">
    <flow :align="{ item: 'vertical', grid: 'cc' }" :graph="{ mode: 'readOnly' }" :shortcut="{ zoomIn: true, zoomOut: true }" id='flow-graph' :grid='grid' :data="graphData"/>
    <flow-custom-node/>
    <flow-action-custom-node/>
  </v-g-editor>
</template>

<script>
import VGEditor, {
  Flow,
} from 'vg-editor';
import workFlows from '@/services/workFlows';
import FlowCustomNode from '@/components/WorkFlowGraphEditor/CustomNodes/FlowCustomNode.vue';
import FlowActionCustomNode from '@/components/WorkFlowGraphEditor/CustomNodes/FlowActionCustomNode.vue';

export default {
  name: 'WorkFlowGraph',
  props: {
    workFlowGraph: {
      required: true,
      type: Object,
    },
  },
  computed: {
    grid() {
      return {
        cell: 25,
      };
    },
    workFlows() {
      return workFlows;
    },
    graphData() {
      return this.workFlowGraph || {};
    },
  },
  components: {
    VGEditor,
    Flow,
    FlowCustomNode,
    FlowActionCustomNode,
  },
};
</script>

<style scoped lang='scss'>
.work-flow-graph {
  width: 100%;
  height: 500px;
}
</style>
